import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import appInsights from "./plugins/appInsights";

const app = createApp(App)

import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const vuetify = createVuetify({
    components,
    directives,
})

app.config.globalProperties.$appInsights = appInsights; // アプリ全体で使用可能に
app.use(router).use(vuetify).mount('#app')